import Archive from '@assets/images/attachments/archive.svg?react'
import Code from '@assets/images/attachments/code.svg?react'
import Default from '@assets/images/attachments/default.svg?react'
import Font from '@assets/images/attachments/font.svg?react'
import Image from '@assets/images/attachments/image.svg?react'
import PDF from '@assets/images/attachments/pdf.svg?react'
import Presentation from '@assets/images/attachments/presentation.svg?react'
import Spreadsheet from '@assets/images/attachments/spreadsheet.svg?react'
import Text from '@assets/images/attachments/text.svg?react'
import Vector from '@assets/images/attachments/vector.svg?react'
import type React from 'react'

import {
  isArchive,
  isCode,
  isFont,
  isImage,
  isPdf,
  isPresentation,
  isSpreadsheet,
  isText,
  isVector,
} from './utils'

interface Props {
  extension: string
}

export const FileIcon: React.FC<Props> = ({ extension }) => {
  if (isPdf(extension)) {
    return <PDF />
  }
  if (isArchive(extension)) {
    return <Archive />
  }
  if (isText(extension)) {
    return <Text />
  }
  if (isSpreadsheet(extension)) {
    return <Spreadsheet />
  }
  if (isCode(extension)) {
    return <Code />
  }
  if (isPresentation(extension)) {
    return <Presentation />
  }
  if (isImage(extension)) {
    return <Image />
  }
  if (isVector(extension)) {
    return <Vector />
  }
  if (isFont(extension)) {
    return <Font />
  }
  return <Default />
}
